import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { get } from '@/utils/storage'
import { isPuXing } from '@/utils/fn'
import { encrypt, decrypt, keyStr, ivStr } from './crypto.js'

const tokenKey = process.env.VUE_APP_STORAGE_TOKEN
// 下面两个数组可能会重复项，重复的情况就是：请求不加密，响应也不加密
// 请求不加密，响应加密
const requestApi = ['/adminapi/common/uploadFile', '/adminapi/common/uploadnewFile']
// 请求加密，响应不加密
const responseApi = ['/webapi/capital/capitalListout', '/webapi/index/exportWarnOpenIds', '/webapi/capital/billDownload', '/webapi/mch/exportList', '/webapi/capital/download']

let baseApi = ''
if (process.env.NODE_ENV === 'development') {
  if (isPuXing()) {
    baseApi = process.env.VUE_APP_PUXING_BASE_API // 导出基路径
  } else {
    baseApi = process.env.VUE_APP_BASE_API // 导出基路径
  }
} else {
  baseApi = process.env.VUE_APP_BASE_API
}

const service = axios.create({
  baseURL: baseApi, // 接口地址前缀
  timeout: 30000 // 请求超时
})

let loading // 全局loading实例

// 请求拦截
service.interceptors.request.use(config => {
  const key = config.method === 'post' ? 'data' : 'params'
  const url = config.url.replace(config.baseURL, '')
  const data = config[key]
  // 打印日志
  if (process.env.NODE_ENV === 'development') {
    console.log('------request------', url, data !== undefined ? data : '---无参数')
  }
  if (store.getters.token) {
    config.headers[tokenKey] = get(tokenKey)
  }
  // 加密处理
  if (requestApi.includes(url) || JSON.stringify(data) === '{}' || !data) {
    config[key] = data
  } else {
    config[key] = { 'data-data': encrypt(JSON.stringify(data), keyStr.replace(/lhf/gm, ''), ivStr.replace(/qql/gm, '')) }
  }
  loading = Loading.service({
    lock: true,
    text: '数据加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.2)'
  })
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

// 响应拦截
service.interceptors.response.use(response => {
  const { status, statusText, config, data } = response
  // 解密处理
  if (responseApi.includes(config.url.replace(config.baseURL, ''))) {
    response.data = data
  } else {
    response.data = JSON.parse(decrypt(response.data.data, keyStr.replace(/lhf/gm, ''), ivStr.replace(/qql/gm, '')))
  }
  // 打印日志
  if (process.env.NODE_ENV === 'development') {
    console.log('------response------', response.config.url.replace(process.env.VUE_APP_BASE_API, ''), response.data)
  }
  if (status === 200) {
    if (response.data.code === 1004) {
      loading.close()
      MessageBox.confirm('您已经登出，您可以取消以继续停留在此页面，或重新登录', '确认注销', {
        confirmButtonText: '重新登陆',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
        location.href = '/'// 登录页
      })
    } else if (response.data.code !== 200 && config.responseType !== 'blob') {
      loading.close()
      Message({
        message: response.data.message,
        type: 'error',
        duration: 3 * 1000
      })
    } else if (response.data.type === 'application/json' && config.responseType === 'blob') {
      loading.close()
      // 针对文件下载出错，返回json类型，而不是文件流处理
      const reader = new FileReader()
      reader.readAsText(response.data, 'utf-8')
      reader.onload = function(evt) {
        Message({
          message: JSON.parse(evt.target.result).message,
          type: 'error',
          duration: 3 * 1000
        })
      }
    }
    loading.close()
    return response.data
  }
  loading.close()
  Message({
    message: statusText,
    type: 'error',
    duration: 3 * 1000
  })
  const err = `requestURL: ${response.request.responseURL}  status: ${status}  msg: ${statusText}`
  return Promise.reject(err)
}, error => {
  loading.close()
  Message({
    message: error.message,
    type: 'error',
    duration: 3 * 1000
  })
  return Promise.reject(error)
})
export default service
